import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
  fullWidth?: boolean;
}

const Input: React.FC<InputProps> = ({ 
  error, 
  fullWidth = true, 
  className = '', 
  ...props 
}) => {
  const baseClasses = 'px-3 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors';
  const widthClasses = fullWidth ? 'w-full' : '';
  const errorClasses = error ? 'border-red-500 focus:ring-red-500 focus:border-red-500' : 'border-gray-300';
  const rtlClasses = 'text-right';
  
  return (
    <input
      className={`${baseClasses} ${widthClasses} ${errorClasses} ${rtlClasses} ${className}`}
      {...props}
    />
  );
};

export default Input; 